/**
 * 检测是否是iOS设备（iPhone或iPad）
 * 支持检测新版iPad（使用桌面版Safari）
 */
export function isIOSDevice(): boolean {
  let isIOS = false;
  
  try {
    if (typeof window !== 'undefined') {
      // 首先检查强制设置的模式
      if (typeof localStorage !== 'undefined') {
        const forcedMode = localStorage.getItem('vocabCardMode');
        if (forcedMode === 'desktop') return false; // 强制桌面模式
        if (forcedMode === 'ipad') return true;     // 强制iPad模式
      }
      
      const userAgent = window.navigator.userAgent.toLowerCase();
      
      // 标准iOS设备检测
      const isStandardIOS = /iphone|ipad|ipod/.test(userAgent);

      // 检测iPad Pro和新款iPad (使用桌面版Safari)
      // 关键: 只有真正的触摸设备才会有触摸事件支持
      const hasTouchSupport = (
        'ontouchend' in document && 
        // 额外检查，确保是真实触摸设备，不是模拟的触摸
        (navigator.maxTouchPoints > 0 || 'maxTouchPoints' in navigator)
      );
    
      // MacBook with Touch Bar也有maxTouchPoints，但不是真正的触摸屏幕设备
      // 所以我们需要进行额外检查
      const isMac = /mac/.test(userAgent);
      const isPossibleIPad = isMac && hasTouchSupport;
      
      // 真实的iPad有较高的触摸点数
      const hasMultiTouch = navigator.maxTouchPoints >= 5;
      
      // 最终判断：是标准iOS设备或可能是运行iPadOS的iPad
      isIOS = isStandardIOS || (isPossibleIPad && hasMultiTouch);
      
      // console.log('Device detection:', { 
      //   userAgent, 
      //   isStandardIOS, 
      //   hasTouchSupport, 
      //   touchPoints: navigator.maxTouchPoints,
      //   isPossibleIPad,
      //   hasMultiTouch,
      //   result: isIOS
      // });
    }
  } catch (e) {
    console.error('Error detecting device type:', e);
  }
  
  return isIOS;
}

/**
 * 获取语言对应的语音合成语言代码
 */
export function getSpeakerLang(language: string): string {
  switch (language.toLowerCase()) {
    case 'english':
      return 'en';
    case 'chinese':
      return 'zh-Hans';
    case 'japanese':
      return 'ja';
    case 'korean':
      return 'ko';
    case 'spanish':
      return 'es';
    default:
      return 'en'; // 默认使用英语
  }
}

/**
 * 格式化时间（秒转换为MM:SS格式）
 */
export function formatTime(timeInSeconds: number): string {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
} 